import { styled } from "styled-components";

export const DeleteSection = styled.div`
  cursor: pointer;
  &:active {
    color: black;
    font-weight: bold;
  }
`;
